import React from 'react'
import { Classes } from '@blueprintjs/core'

export default function Skeleton({ withButton }: { withButton?: boolean }) {
  return withButton ? (
    <>
      <div className={Classes.SKELETON}>placeholder</div>
      <div className={`z-1 mt-1 ${Classes.SKELETON}`}>
        <button className="p-1 font-medium text-xs text-grey-600 hover:text-grey-700">
          placeholder
        </button>
      </div>
    </>
  ) : (
    <div className={Classes.SKELETON}>placeholder</div>
  )
}
